<template>
  <Card class="h-full flex flex-col">
    <CardHeader class="flex flex-row items-center justify-between p-4 border-b">
      <CardTitle>Template</CardTitle>
      <div class="flex gap-2">
        <Button variant="outline" size="sm" @click="toggleSplitView">
          <SplitIcon class="w-4 h-4 mr-2" />
          {{ splitView ? 'Code Only' : 'Split View' }}
        </Button>
      </div>
    </CardHeader>
    <CardContent class="flex-1 p-0 overflow-hidden">
      <SplitView v-if="splitView" class="h-full">
        <template #left>
          <ComponentLibrary @add-component="addComponent" />
        </template>
        <template #right>
          <MonacoEditor
            v-model="templateCode"
            language="html"
            :options="editorOptions"
            class="h-full"
          />
        </template>
      </SplitView>
      <MonacoEditor
        v-else
        v-model="templateCode"
        language="html"
        :options="editorOptions"
        class="h-full"
      />
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { SplitIcon } from 'lucide-vue-next'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, } from '@/components/ui/card';
import { ref,watch } from 'vue'
import MonacoEditor from '@/components/ui/MonacoEditor.vue'
import ComponentLibrary from './ComponentLibrary.vue'
import SplitView from '@/components/ui/SplitView.vue'

const props = defineProps<{
  modelValue: string
}>()

const emit = defineEmits(['update:modelValue', 'add-component'])

const templateCode = ref(props.modelValue)
const splitView = ref(false)
const editorOptions = {
  minimap: { enabled: false },
  fontSize: 14,
  tabSize: 2
}

const toggleSplitView = () => {
	  splitView.value = !splitView.value
}
watch(templateCode, (newVal:string) => {
  emit('update:modelValue', newVal)
})

const addComponent = (code: string) => {
  templateCode.value += `\n${code}`
  emit('add-component', code)
}
</script>
